<template>
  <v-alert
    v-if="isDemo"
    type="info"
    dense
    text
    class="demo-banner mb-0"
  >
    <strong>{{ $t('demo_mode') }}:</strong> {{ $t('demo_mode_notice') }}
  </v-alert>
</template>

<script>
import { isDemoMode } from '@/config'

export default {
  name: 'DemoBanner',
  computed: {
    isDemo() {
      return isDemoMode()
    },
  },
}
</script>

<style scoped>
.demo-banner {
  border-radius: 0;
}
</style>
